import { useQuery } from '@tanstack/react-query'
import { useUnit } from 'effector-react'

import type { PublicProfileInfo } from '@portal/portal-api'

import { $portalProfile } from '@/entities/profile/portal'
import { getPublicProfileByPublicId } from '@/entities/profile/public'

export function usePublicProfileInfo(
    publicID: string | undefined,
    opts: { enabled?: boolean } = {}
): PublicProfileInfo | null | undefined {
    const { data: info } = useQuery({
        queryKey: ['getPublicProfileByPublicId', publicID],
        queryFn: () => (publicID ? getPublicProfileByPublicId(publicID) : null),
        enabled: publicID !== undefined && (opts.enabled ?? true),
    })

    // use my profile with a more recent data
    const myProfile = useUnit($portalProfile)
    if (publicID && publicID === myProfile?.publicId) {
        return myProfile
    }

    return info
}
